import ImageLayer from '@planet/maps/layer/Image';
import ImageCanvas from '@planet/maps/source/ImageCanvas';
import GeoJSON from 'ol/format/GeoJSON';
import {getVectorContext} from 'ol/render';
import {bool, object} from 'prop-types';
import React, {useMemo} from 'react';

import {getWatermark} from '@explorer/util/map';
import {CLIP_STYLE} from '@explorer/util/map-edit-styles';

const WatermarkLayer = ({clipGeometry, visible = false}) => {
  const {onPrerender, onPostrender} = useMemo(() => {
    const geometry = clipGeometry
      ? new GeoJSON().readGeometry(clipGeometry)
      : null;

    return {
      onPrerender: event => {
        const {context} = event;
        context.save();
        if (geometry) {
          const vectorContext = getVectorContext(event);
          vectorContext.setStyle(CLIP_STYLE);
          vectorContext.drawGeometry(geometry);
          context.clip();
        }
      },
      onPostrender: event => {
        event.context.restore();
      },
    };
  }, [clipGeometry]);

  return (
    <ImageLayer
      visible={visible}
      onPrerender={onPrerender}
      onPostrender={onPostrender}
    >
      <ImageCanvas
        options={{
          canvasFunction: getWatermark,
          ratio: 1,
        }}
      />
    </ImageLayer>
  );
};

WatermarkLayer.propTypes = {
  visible: bool,
  clipGeometry: object,
};

export default WatermarkLayer;
